const DEFAULT_URL = "https://s3.eu-west-2.amazonaws.com/co.quikstep.dev/assets/ringtone-for-calling.mp3";

class RingtoneManager {
  private audio: HTMLAudioElement | null = null;
  private playing = false;
  private url: string;

  constructor(url?: string) {
    this.url = url || DEFAULT_URL;
  }

  init(url?: string) {
    if (url) this.url = url;
    if (!this.audio) {
      this.audio = new Audio(this.url);
      this.audio.crossOrigin = "anonymous";
      this.audio.preload = "auto";
      this.audio.loop = true;
      this.audio.volume = 0.9;
      // start muted — we'll unmute on play
      this.audio.muted = true;
    }
  }

  async play() {
    try {
      if (!this.audio) this.init();
      const a = this.audio!;
      // ensure src preserved
      if (!a.src || !a.src.includes(this.url)) {
        a.src = this.url;
        try { a.load(); } catch (e) { /* ignore */ }
      }

      a.loop = true;
      a.muted = false;
      // start from beginning
      try { a.currentTime = 0 } catch (e) {}
      // try resume AudioContext (best-effort)
      try {
        const AudioContextClass = (window as any).AudioContext || (window as any).webkitAudioContext;
        if (AudioContextClass) {
          const ac = new AudioContextClass();
          if (ac.state === 'suspended' && ac.resume) {
            await ac.resume();
          }
        }
      } catch (e) { /* ignore */ }

      await a.play();
      this.playing = true;
      // small console aid for debug
      // console.log('RingtoneManager: play OK');
      return true;
    } catch (err) {
      console.error('RingtoneManager: play failed', err);
      this.playing = false;
      return false;
    }
  }

  stop() {
    try {
      if (!this.audio) return;
      const a = this.audio;
      a.pause();
      try { a.currentTime = 0; } catch (e) {}
      a.loop = false;
      a.muted = true; // keep src intact but mute, so future plays work
      this.playing = false;
      // console.log('RingtoneManager: stopped (soft)');
    } catch (err) {
      console.warn('RingtoneManager: stop error', err);
    }
  }

  isPlaying() {
    return this.playing;
  }
}

const ringtoneManager = new RingtoneManager();
export default ringtoneManager;
